var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 18 18","aria-labelledby":_vm.iconName,"role":"presentation"}},[_c('g',{attrs:{"fill":_vm.iconColor}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }